export const findNextFocusItemRef = ({ action: direction, focusableItems, focusedItemRef, }) => {
    if (!focusableItems.length || !focusedItemRef) {
        return null;
    }
    let focusedItemIndex = focusableItems
        .map((i) => i.itemRef)
        .indexOf(focusedItemRef);
    if (focusedItemIndex < 0) {
        return direction === 'ArrowDown'
            ? focusableItems[0].itemRef
            : focusableItems[focusableItems.length - 1].itemRef;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- intentional ternary/short-circuit statement (allowed on master; v8 newly added this rule)
    direction === 'ArrowDown' ? focusedItemIndex++ : focusedItemIndex--;
    focusedItemIndex =
        (focusedItemIndex + focusableItems.length) % focusableItems.length;
    return focusableItems[focusedItemIndex]?.itemRef || null;
};
